module.exports = __webpack_public_path__ + "static/media/cardReveal.a27a6345.wav";